"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rebass = require("rebass");

var _ComponentWrapper = _interopRequireDefault(require("../ComponentWrapper"));

var _MarkdownRenderer = _interopRequireDefault(require("../MarkdownRenderer"));

var _Banner = _interopRequireDefault(require("../Banner"));

var _Typography = require("../Typography");

var TextBlock = function TextBlock(_ref) {
  var html = _ref.html,
      heading = _ref.heading,
      banner = _ref.banner,
      id = _ref.id,
      rest = _objectWithoutProperties(_ref, ["html", "heading", "banner", "id"]);

  return /*#__PURE__*/_react.default.createElement(_ComponentWrapper.default, Object.assign({
    id: id
  }, rest), heading && /*#__PURE__*/_react.default.createElement(_Typography.PageTitle, {
    mb: "large"
  }, heading), banner && /*#__PURE__*/_react.default.createElement(_rebass.Box, {
    mb: "large"
  }, /*#__PURE__*/_react.default.createElement(_Banner.default, banner)), /*#__PURE__*/_react.default.createElement(_MarkdownRenderer.default, {
    html: html
  }));
};

TextBlock.propTypes = {
  id: _propTypes.default.string,
  heading: _propTypes.default.string,
  html: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.node, _propTypes.default.string]),
  banner: _propTypes.default.shape({
    image: _propTypes.default.shape({}),
    label: _propTypes.default.string
  })
};
TextBlock.defaultProps = {
  id: '',
  heading: '',
  html: '',
  banner: null
};
var _default = TextBlock;
exports.default = _default;